module.exports = __webpack_public_path__ + "static/media/Quality_Assurance_and_Inspection.4c2102ff.JPG";